import { render, staticRenderFns } from "./Polygons.vue?vue&type=template&id=37f6fa2a&"
import script from "./Polygons.vue?vue&type=script&lang=js&"
export * from "./Polygons.vue?vue&type=script&lang=js&"
import style0 from "./Polygons.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports